export default __webpack_public_path__ + "static/media/background.cdbe645b.jpg";